import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const getDependentQLEReasonOptions = info =>
  call(websocketFetch, 'get_dependent_qle_reason_options', info);
